import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-8 mt-4" }
const _hoisted_3 = { key: 1 }

import { defaultInitiative, Initiative } from '@/models/initiative.model';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { ContentStoreActions } from '@/stores/content.store';
import { ref } from 'vue';
import { useStore } from 'vuex';
import RichTextField from '../common/RichTextField.vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'InitiativeShortForm',
  setup(__props) {

const store = useStore<ShiftCMSState>();
const { t } = useI18n();

const value = ref<Initiative>({ ...defaultInitiative });
const valid = ref<boolean>(true);
const created = ref<boolean>(false);

async function save() {
  if (!valid.value) {
    return;
  }

  const result = await store.dispatch(
    ContentStoreActions.CreateInitiative,
    value.value,
  );

  if (result.status) {
    store.dispatch(Actions.ShowNotification, {
      type: 'success',
      message: t('initiative.edit.created'),
    });
    store.dispatch(ContentStoreActions.GetInitiativesByContentEditor);
    created.value = true;
  } else {
    store.dispatch(Actions.ShowNotification, {
      type: 'warning',
      message: result.message,
    });
  }
}

function ok() {
  store.commit(Mutations.HideDrawer);
}

const rules = {
  required: (value: string) => !!value || t('initiative.edit.required'),
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('initiative.list.add')), 1),
      (!created.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('initiative.edit.intro')), 1),
            _createVNode(_component_v_form, {
              modelValue: valid.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((valid).value = $event)),
              onSubmit: _withModifiers(save, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: value.value.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.title) = $event)),
                  label: _ctx.$t('initiative.edit.name'),
                  hint: _ctx.$t('initiative.edit.nameHint'),
                  rules: [rules.required],
                  valid: false
                }, null, 8, ["modelValue", "label", "hint", "rules"]),
                _createVNode(RichTextField, {
                  label: _ctx.$t('initiative.edit.description'),
                  hint: _ctx.$t('initiative.edit.descriptionHint'),
                  modelValue: value.value.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value.value.description) = $event)),
                  height: 300,
                  media: value.value.media,
                  rules: [rules.required]
                }, null, 8, ["label", "hint", "modelValue", "media", "rules"]),
                _createVNode(_component_v_container, { class: "mt-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.save')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (created.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_alert, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.created_intro1')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_alert, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.created_intro2')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_alert, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.created_intro3')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_alert, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.created_intro4')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_container, { class: "mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: ok
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.ok')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})